const BLACK = '#000000';
const WHITE = '#ffffff';

export default {
  black: BLACK,
  white: WHITE,
  red: {
    v_100: '#FFD9D3',
    v_200: '#FFB4A7',
    v_300: '#FF8E7C',
    v_400: '#FF6950',
    v_500: '#FF4324',
    v_600: '#D21E00',
  },
  pink: {
    v_100: '#FFE5E8',
    v_200: '#FFCCD1',
    v_300: '#FFB2BB',
    v_400: '#FF99A4',
    v_500: '#FF7F8D',
    v_600: '#F76474',
  },
  blue: {
    v_100: '#D9E1FD',
    v_200: '#B4C3FB',
    v_300: '#8EA4F9',
    v_400: '#6986F7',
    v_500: '#4368F5',
    v_600: '#2547F3',
  },
  lightblue: {
    v_100: '#CCEAFC',
    v_200: '#99D5FA',
    v_300: '#66C1F7',
    v_400: '#33ACF5',
    v_500: '#0097F2',
    v_600: '#0079C2',
  },
  darkgreen: {
    v_100: '#CCDDD6',
    v_200: '#99BBAD',
    v_300: '#669A85',
    v_400: '#33785C',
    v_500: '#005633',
    v_600: '#00331E',
  },
  green: {
    v_100: '#CCF4D8',
    v_200: '#99E9B1',
    v_300: '#66DD8A',
    v_400: '#33D263',
    v_500: '#00C73C',
    v_600: '#00992E',
  },
  orange: {
    v_100: '#FFE4CC',
    v_200: '#FFC899',
    v_300: '#FFAD66',
    v_400: '#FF9133',
    v_500: '#FF7600',
    v_600: '#E56A00',
  },
  yellow: {
    v_100: '#FFF5CC',
    v_200: '#FFEA99',
    v_300: '#FFE066',
    v_400: '#FFD533',
    v_500: '#FFCB00',
    v_600: '#E5B700',
  },
  grey: {
    v_50: WHITE,
    v_100: '#F5F5F5',
    v_200: '#E6E6E6',
    v_300: '#CCCCCC',
    v_400: '#999999',
    v_700: '#666666',
    v_800: '#333333',
    v_900: BLACK,
  },
};
